<template>
  <v-btn
    class="btn"
    large="large"
    color="#FFFFFF"
    flat="flat"
    :disabled="disabled"
    :block="block"
    :type="type"
    :loading="loading"
    @click.native="onClick($event)"
  >
    <span class="grey--text btn--text">{{ text }}</span>
  </v-btn>
</template>

<script>
import BtnTemplate from './BtnTemplate.vue';

export default {
  name: 'BtnCancel',
  extends: BtnTemplate,
};
</script>

<style lang="stylus" scoped>
  .v-btn
    border 1px solid #e46e6e
  .btn--text
    color #c33c3c !important
    font-weight bold
    font-size 14px
    letter-spacing 0.8px
</style>
